module.exports = __webpack_public_path__ + "img/school_qzyc.784a49cf.png";